/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import React, { Component,createRef } from "react";
import { connect } from "react-redux";
import {Link} from "react-router-dom";
import {Templates,Redux} from "@ora/recursos";
import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";
import { checkObjects, getColorPalette } from "helpers/Utils";

import numeral from "numeral";
import 'numeral/locales';

import qs from 'query-string'
import { Chart } from "react-google-charts";
import $ from 'jquery'
import dt from 'datatables.net'
import "css/reportes/scrollbar.css";
import typeahead from 'corejs-typeahead'
import Carousel from 'react-material-ui-carousel'

import Highcharts from 'highcharts/highmaps';


import "css/reportes/fichaespecie.css";
import "css/frontend/ficha-especie.scss"
import "css/frontend/dasboard_trafico.css"
import {  
  Card
   } from 'react-bulma-components';
import { prependTraces } from "plotly.js";
import defaultImg from 'img/default.png'
import { SpinLoaderStyle } from "layouts/mainsection/components/Loader";
import IncidenciasYear from "./CDashsboardTrafico/IncidenciasYear";
import PorcentajeTotalIncidenciasEspecies from "./CDashsboardTrafico/PorcentajeTotalIncidenciasEspecies";
import PorcenPOPMTotalIncidencias from "./CDashsboardTrafico/PorcenPOPMTotalIncidencias";
import PorcenPOTotalIncidencias from "./CDashsboardTrafico/PorcenPOTotalIncidencias";
import BaseDatosOtca from "./CDashsboardTrafico/InformacionGeneral/FuentesExtraccion/BaseDatosOtca";
import PorInfoAporPMOIDBOTCA from "./CDashsboardTrafico/InformacionGeneral/FuentesExtraccion/PorInfoAporPMOIDBOTCA";
//import EspeciesCantidadIncidencias from "./CDashsboardTrafico/MercadosDemandas/EspeciesCantidadIncidencias";
import OETInvolucradasIncidente from "./CDashsboardTrafico/OtrasEspeciesTraficadas/OETInvolucradasIncidente";
import OETInvolucradasIncidenteTreemap from "./CDashsboardTrafico/OtrasEspeciesTraficadas/OETInvolucradasIncidenteTreemap";
import MOMetoTranspTrafEspecies from "./CDashsboardTrafico/ModusOperandi/MOMetoTranspTrafEspecies";
import MOEspeDetecEncontrada from "./CDashsboardTrafico/ModusOperandi/MOEspeDetecEncontrada";
import MOMetDecIncBDOTCA from "./CDashsboardTrafico/ModusOperandi/MOMetDecIncBDOTCA";
import MOMetDetIncBDOTCASD from "./CDashsboardTrafico/ModusOperandi/MOMetDetIncBDOTCASD";
import MapGoogle2 from "views/util/MapGoogle2";
import MDTipoProducto from "./CDashsboardTrafico/MercadosDemandas/MDTipoProducto";
import RTTraficoEspecies from "./CDashsboardTrafico/RutasTrafico/RTTraficoEspecies";
import FITRazonComActoIlegTra from "./CDashsboardTrafico/ImpulsanTrafico/FITRazonComActoIlegTra";
import FITMultasSancionesFiveEsp from "./CDashsboardTrafico/ImpulsanTrafico/FITMultasSancionesFiveEsp";
import RTRutasNacionalesTra from "./CDashsboardTrafico/RutasTrafico/RTRutasNacionalesTra";
import FITEstMultUSDIncidFiveEsp from "./CDashsboardTrafico/ImpulsanTrafico/FITEstMultUSDIncidFiveEsp";
import FITCodDefiTipProd from "./CDashsboardTrafico/ImpulsanTrafico/FITCodDefiTipProd";
import FITValoEstiUSDTipProdEsp from "./CDashsboardTrafico/ImpulsanTrafico/FITValoEstiUSDTipProdEsp";
import RTTraficoEspeciesNacional from "./CDashsboardTrafico/RutasTrafico/RTTraficoEspeciesNacional";
import { Button, Paper } from "@material-ui/core";
import { faMapPin } from "@fortawesome/free-solid-svg-icons";
import { styleInfo } from "./CDashsboardTrafico/ImpulsanTrafico/info";
import PCDTMapaIncidencias from "./CDashsboardTrafico/PuntosCalorTrafico/PCDTMapaIncidencias";
import { JsoftMenu } from "./JsoftMenu";

let { set_datapage, getMapStateDefault  } = Redux.Actions.DataPageAction

numeral.locale('es-ES');

window.Highcharts = Highcharts
require('@highcharts/map-collection/custom/world');
require('@highcharts/map-collection/custom/south-america');
$.DataTable = dt
$.typeahead = typeahead
// ChartJS.register(...registerables);


const hiddenBtnGenerar = {
  height: '0px',
  overflow: 'hidden',
};

class DashboardTrafico extends Component {
    cPCDTPuntCalInciTraMapInstance = null
    cRTRutasNacionalesTraMapInstance=null
    filter = {
        buscar: '' 
    }
    selects = {
      cites: [],
      especies: []
    }
    currentSelect = {
      cite: '',
      especie: 0,
      dataEspecie: null
    }
    datatable=null

    refSelectEspecies = null
    refSelectCites = null
    refSelectReyno = null
    refSelectGrupos = null
    refSelectYear = null
    refSelectPais = null
    refSelectPaisYear = null
    refSelTipoRerporte = null

    BGMapChart = '#81d4fa'

    chartMapGlobal = null

    paramsURL = {}
    constructor (props) {
        super(props)
        this.requestInit = axios.CancelToken.source()
        let objFinal = {}
      
  
        this.paramsURL =qs.parse(this.props.location.search)
        
         
        objFinal = {
          header: false,
          speciesstudi:false,
          cPCDTPuntCalInciTraList: [],
          cPCDTPuntCalInciTraTitleCurrent: '',
          cPCDTPuntCalInciTraListFound: [],
        panels: {
          informacionGeneral: true,
          puntosCalorTrafico: true,
          rutasTrafico: true,
          principalesMercadosDemandas: true,
          otrasEspeciesTraficadas: true,
          modusOperandi: true,
          factoresImpulsanTraf: true,
        },
        chartList: {
          incidenciasYear: null,
          porcentajeTotalIncidenciaEspecie: null,
          porcenPOPMTotalIncidencias: null,
          porcenPOTotalIncidencias: null,
          fuentesExtraccion: {
            extraccionBaseDatosOTCA: null,
            porInfoAporPMOIDBOTCA: null
          },
        },
         //Urtas de Trafico
        chartListRT: {
          cRTTraficoEspecies: null,
          cRTRutasNacionalesTra: null,
          cRTRutasNacionalesTraData: [],
          cRTRutasNacionalesTraDataEspecies: [],
          cRTRutasNacionalesTraDataAll: [],
          cRTRutasNacionalesTraTitle: null,
          cRTRutasNacionalesTraMapInstance: null,
          cRTRutasNacionalesTraGoogleMapInstance: null,
          cRTRutasNacionalesTraPolyLines: [],
          cRTRutasNacionalesTraMarkers: [],
        },
         //Mercados y Demandas
        chartListMD: {
          especiesCantidadIncidencias: null,
          cMDTipoProducto: null,
          cMDTipoProductoData: [],
          cMDTipoProductoTitle: '',
          cMDTipoProductoInstance: null,
          cMDTipoProductoEspecies: [],
          cMDTipoProductoProductos: []
        },
         //Puntos de Calor de Trafico
         chartListPCDT: {
           cPCDTPuntCalInciTra: null,
           cPCDTPuntCalInciTraTitle: '',
           cPCDTPuntCalInciTraDescription: '',
           cPCDTPuntCalInciTraMapInstance: null,//google
           cPCDTPuntCalInciTraMapData: [],
           cPCDTPuntCalInciTraMapInstanceTitle: '',
           
           cPCDTPuntCalInciTraGoogleMapInstance: null,

           cPCDTMapaIncidencias: null,
           cPCDTMapaIncidenciasData: null,
           cPCDTMapaIncidenciasInstance: null,
           cPCTMapaIncidenciasTitle: '',
           cPCTMapaIncidenciasTitleDescription: '',
           cPCTMapaIncidenciasIncidencias: [],
         },
         //Otras Especies Involucradas
         chartListOEI: {
          cOETInvolucradasIncidente: null,
          cOETInvolucradasIncidenteTreemap: null
         },
         //Modus Operandi
         chartListMOP: {
          cMOMetoTranspTrafEspecies: null,
          cMOEspeDetecEncontrada: null,
          cMOMetDecIncBDOTCA: null,
          cMOMetDetIncBDOTCASD: null,
         },
         chartListFIT: {
          cFITRazonComActoIlegTra: null,
          cFITMultasSancionesFiveEsp: null,
          cFITEstMultUSDIncidFiveEsp: null,
          cFITCodDefiTipProd: null,
          cFITValoEstiUSDTipProdEsp: null,
         }
            
        };
        if (this.paramsURL.t !== undefined && (this.paramsURL.t >= 1 && this.paramsURL.t <=3)) {
          objFinal.currentTab = +this.paramsURL.t
        }
        this.state = objFinal
                 
          // this.refSelectEspecies = createRef()
          // this.refSelectCites = createRef()
          // this.refSelectReyno = createRef()
          // this.refSelectGrupos = createRef()
          // this.refSelectYear = createRef()
          this.refSelProductos = createRef()
          this.refSelEspecies = createRef()
          this.refSelEspeciesCalorTrafico = createRef()
          this.refSelIncidenciasCalorTrafico = createRef()
          this.refSelTipoRerporte= createRef()

        
        
       
    }
    
 
    setDataPage = () => {
      
       this.props.set_datapage(
           { 
            titulo: this.props.language('dashb_trafico_ilegal_titulo'),
            isbackend:false,
            be_itemselect:"exportaciones_cites_trafico",//clave de item del menu backend que se debe activar 
          });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
      

    }
    componentDidMount() {

        this.setDataPage()

      this.init_report_state()

      this.load_header()
  

       

    }
    init_report_state(){
      this.setState({
        chartList: {
          ...this.state.chartList,
          incidenciasYear: SpinLoaderStyle,
          porcentajeTotalIncidenciaEspecie: SpinLoaderStyle,
          porcenPOPMTotalIncidencias: SpinLoaderStyle,
          porcenPOTotalIncidencias: SpinLoaderStyle,
          fuentesExtraccion: {
            extraccionBaseDatosOTCA: SpinLoaderStyle,
            porInfoAporPMOIDBOTCA: SpinLoaderStyle,
          }
          
        },
        chartListRT: {
          ...this.state.chartListRT,
          cRTTraficoEspecies: SpinLoaderStyle,
          cRTRutasNacionalesTra: SpinLoaderStyle,
        },
        chartListMD: {
         ...this.state.chartListMD,
          especiesCantidadIncidencias: SpinLoaderStyle,
          cMDTipoProducto: SpinLoaderStyle,
        },
        chartListPCDT: {
          ...this.state.chartListPCDT,
          cPCDTPuntCalInciTra: SpinLoaderStyle,
          cPCDTMapaIncidencias: SpinLoaderStyle,
        },
        chartListOEI: {
         ...this.state.chartListOEI,
          cOETInvolucradasIncidente: SpinLoaderStyle,
          cOETInvolucradasIncidenteTreemap: SpinLoaderStyle
        },
        chartListMOP: {
         ...this.state.chartListMOP,
         cMOMetoTranspTrafEspecies: SpinLoaderStyle,
         cMOEspeDetecEncontrada: SpinLoaderStyle,
         cMOMetDecIncBDOTCA: SpinLoaderStyle,
         cMOMetDetIncBDOTCASD: SpinLoaderStyle
        },
        chartListFIT: {
          ...this.state.chartListFIT,
          cFITRazonComActoIlegTra: SpinLoaderStyle,
          cFITMultasSancionesFiveEsp: SpinLoaderStyle,
          cFITEstMultUSDIncidFiveEsp: SpinLoaderStyle,
          cFITCodDefiTipProd: SpinLoaderStyle,
          cFITValoEstiUSDTipProdEsp: SpinLoaderStyle,
        }
    
            

     
      })
    }
    load_reports(){
      //this.load_especies_estudiadas()
      this.load_incidenciasYear()//check
      this.load_totalIncidenciaEspecie()//check
      this.load_porcenPOPMTotalIncidencias()//check
      this.load_porcenPOTotalIncidencias()//check
      this.load_extraccionBaseDatosOTCA()//check
      this.load_porInfoAporPMOIDBOTCA()//check
      
      //PUNTOS DE CALOR DE TRÁFICO ILEGAL
      this.load_cRTTraficoEspecies()//check
      this.load_cPCTMapaIncidencias()
      
      //this.load_especiesCantidadIncidencias()
      this.load_cMDTipoProducto()//check
      //this.load_cOETInvolucradasIncidente()//check
      this.load_cOETInvolucradasIncidenteTreemap()//check
      this.load_cMOMetoTranspTrafEspecies()//check
      this.load_cMOEspeDetecEncontrada()//check
      this.load_cMOMetDecIncBDOTCA()//check
      this.load_cMOMetDetIncBDOTCASD()
      

      this.load_cFITRazonComActoIlegTra()
      this.load_cFITMultasSancionesFiveEsp()
      this.load_cFITEstMultUSDIncidFiveEsp()
      //this.load_cFITCodDefiTipProd()
      this.load_cFITValoEstiUSDTipProdEsp()

      if (!window.google) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = `https://maps.google.com/maps/api/js?key=AIzaSyC5_bKVZPjdddZkv0IJeGPXPl8FNZOE-4M&libraries=visualization`;
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
        // Below is important. 
        //We cannot access google.maps until it's finished loading
        s.addEventListener('load', e => {
          this.load_withGoogle()
        })
      } else {
        this.load_withGoogle()
      }
    }
    load_header = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/chartsJson`), {
        params: {
          target: 'cElementosCabezera'
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          header: {
            titulo: res.data.data.titulo,
            subtitulo: res.data.data.subtitulo,
            carousel: res.data.data.carousel,
            filters: res.data.data.filters
          }
        })
        this.load_reports()
      })
    }
    load_especies_estudiadas = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/especies`), {
        params: {
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          speciesstudi: res.data.data
        })
      })
    }
    load_cPCTMapaIncidencias = () => {
      

    }
    load_withGoogle = () => {
      this.load_cRTRutasNacionalesTraGG()//check
      this.load_cPCDTPuntCalInciTra()
    }
    load_cFITValoEstiUSDTipProdEsp = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'cFITValoEstiUSDTipProdEsp',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          chartListFIT: {
            ...this.state.chartListFIT,
            cFITValoEstiUSDTipProdEsp: <FITValoEstiUSDTipProdEsp key="FITValoEstiUSDTipProdEsp"
            title={ res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")" } 
            description={ res.data.description } 
            data={ res.data.data }/>,
          }
        })

      })
    }
    load_cFITCodDefiTipProd = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/chartsJson`), {
        params: {
          target: 'cFITCodDefiTipProd'
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          chartListFIT: {
            ...this.state.chartListFIT,
            cFITCodDefiTipProd: <FITCodDefiTipProd key="FITCodDefiTipProd"
            title={ res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")" } 
            description={ res.data.description } 
            data={ res.data.data }/>,
          }
        })

      })
    }
    load_cFITEstMultUSDIncidFiveEsp = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'cFITEstMultUSDIncidFiveEsp',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          chartListFIT: {
            ...this.state.chartListFIT,
            cFITEstMultUSDIncidFiveEsp: <FITEstMultUSDIncidFiveEsp key="FITEstMultUSDIncidFiveEsp"
            title={ res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"} 
            description={ res.data.description } 
            data={ res.data.data }/>,
          }
        })

      })
    }
    load_cFITMultasSancionesFiveEsp = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'cFITMultasSancionesFiveEsp',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          chartListFIT: {
            ...this.state.chartListFIT,
            cFITMultasSancionesFiveEsp: <FITMultasSancionesFiveEsp key="FITMultasSancionesFiveEsp"
              title={ res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")" } 
              description={ res.data.description } 
              data={ res.data.data }/>,
          }
        })

      })
    }
    load_cFITRazonComActoIlegTra = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'cFITRazonComActoIlegTra',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          chartListFIT: {
            ...this.state.chartListFIT,
            cFITRazonComActoIlegTra: <FITRazonComActoIlegTra key="FITRazonComActoIlegTra"
            title={ res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")" } 
            description={ res.data.description } 
            data={ res.data.data }/>,
          }
        })

      })
    }

    load_cRTTraficoEspecies = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'cRTTraficoEspecies',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        
        let formatData = res.data.data        
        let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"

        this.setState({
          chartListRT: {
            ...this.state.chartListRT,
            cRTTraficoEspecies: <RTTraficoEspecies key="RTTraficoEspecies"
            title={title} 
            description={ res.data.description } 
            data={formatData}/>,
          }
        })

      })
    }
    load_cRTRutasNacionalesTraGG = () => {
      this.setState({
        chartListRT: {
          ...this.state.chartListRT,
          cRTRutasNacionalesTra: <MapGoogle2
          id="cRTRutasNacionalesTraGG"
          title={'title'} 
          height="25em"
          options={{
            zoom: 3.5,
            disableDefaultUI: true,
            center: { lat: -3.8357364, lng: -66.2325682 },
            mapTypeId: "roadmap",
          }}
          onMapLoad={(map, google) => {
            this.cRTRutasNacionalesTraMapInstance = map
            this.setState({
              chartListRT: {
                ...this.state.chartListRT,
                // cRTRutasNacionalesTraTitle: res.data.title,
                //cRTRutasNacionalesTraMapInstance: map,
                cRTRutasNacionalesTraGoogleMapInstance: google
              }
            })
          


            axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
              params: {
                target: 'cRTRutasNacionalesTra',
                recurso:this.refSelTipoRerporte.current.value
              },
              cancelToken: this.requestInit.token
            }).then(res => {
              this.setState({
                chartListRT: {
                  ...this.state.chartListRT,
                  cRTRutasNacionalesTraTitle: res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")",
                  cRTRutasNacionalesTraDataEspecies: res.data.data.especies,
                  cRTRutasNacionalesTraDataAll: res.data.data.rows
                }
              })
            })           
           
          }}
          loader={SpinLoaderStyle}
          data={[]}
          />,
        }
      })

   
    }
    load_cRTRutasNacionalesTra = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/chartsJson`), {
        params: {
          target: 'cRTRutasNacionalesTra'
          // target: 'cRTTraficoEspecies'
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        
        let formatData = res.data.data

        let title = res.data.title
        
        this.setState({
          chartListRT: {
            ...this.state.chartListRT,
            // cRTRutasNacionalesTra: <RTRutasNacionalesTra 
            cRTRutasNacionalesTra: <RTTraficoEspeciesNacional key="RTTraficoEspeciesNacional"
            title={title} 
            description={ res.data.description } 
            data={formatData}/>,
          }
        })

      })
    }
    onChange_selProducto = (e) => {
   

      // legend.title.text.textSetter('asd')
      if (+e.target.value !== -1) {
        let objProducto = this.state
        .chartListMD
        .cMDTipoProductoData[this.refSelEspecies.current.value].productos[e.target.value]
        
        let formatData = objProducto
          .country_occurence
          .map(itemP => [itemP[0].toLowerCase(), itemP[2]])

        let colorAxisClass = formatData.map(item => +item[1]).filter((a, b, c) => c.indexOf(a) === b).sort((a, b) => a - b).map(item => ({to: item, from: item}))
        // console.log(formatData, formatData.map(item => +item[1]).filter((a, b, c) => c.indexOf(a) === b).sort((a, b) => a - b))

        this.state
          .chartListMD
          .cMDTipoProductoInstance.series[0]
          .setData(formatData)
        // console.log('yuca', this.state
        //   .chartListMD
        //   .cMDTipoProductoInstance)
        this.state
          .chartListMD
          .cMDTipoProductoInstance
          .legend
          .update({
            enabled: true,
            title: {text: `${objProducto.product_type}`}
          })
          


        this.state
          .chartListMD
          .cMDTipoProductoInstance
          .colorAxis[0].update({
            dataClasses: colorAxisClass
          })
          
        
      } else {
        if (this.state
          .chartListMD
          .cMDTipoProductoInstance.series !== undefined) {
            this.state
            .chartListMD
            .cMDTipoProductoInstance.series[0]
            .setData([])
          }
      }
    }
    onChange_selEspecies = (e) => {
      this.refSelProductos.current.value = -1
      if (this.state
        .chartListMD
        .cMDTipoProductoInstance.series !== undefined) {
          //Reiniciar titulo
          this.state
            .chartListMD
            .cMDTipoProductoInstance
            .legend.update({
              title: {text: ''}
            })
            
          //Reiniciar classColor
          this.state
            .chartListMD
            .cMDTipoProductoInstance
            .colorAxis[0].update({
              dataClasses: []
            })


          this.state
          .chartListMD
          .cMDTipoProductoInstance.series[0]
          .setData([])
        }
      this.setState({
        chartListMD: {
          ...this.state.chartListMD,
          cMDTipoProductoProductos: []
        }
      })
      
      let find = this.state
        .chartListMD
        .cMDTipoProductoData[e.target.value]
      let res = []
      if (find !== undefined) {
        res = find.productos.map((item, index) => [index, item.product_type])
      } 
      this.setState({
        chartListMD: {
          ...this.state.chartListMD,
          cMDTipoProductoProductos: res
        }
      })
    }
    onChange_checkSpeciesPCTracIle = (e) => {
      
      //this.refSelIncidenciasCalorTrafico.current.value = -1
      if (+e.target.value === -1) {
        if (this.state
          .chartListPCDT
          .cPCDTMapaIncidenciasInstance.series !== undefined) {
            
            this.state
              .chartListPCDT
              .cPCDTMapaIncidenciasInstance.series[0]
              .setData([])

            this.state
              .chartListPCDT
              .cPCDTMapaIncidenciasInstance
              .legend
              .update({
                enabled: true,
                title: 'None'
              })
          }
      this.onChange_checkSpecies({ target: e.target })
      this.state
        .chartListPCDT
        .cPCDTMapaIncidenciasInstance.series[0]
        .setData([])

      this.state
        .chartListPCDT
        .cPCDTMapaIncidenciasInstance
        .legend
        .update({
          enabled: true,
          title: ''
        })

      this.state
        .chartListPCDT
        .cPCDTMapaIncidenciasInstance
        .colorAxis[0].update({
          dataClasses: []
        })
        return false
      }
      if (this.state
        .chartListPCDT
        .cPCDTMapaIncidenciasInstance.series !== undefined) {
          //Reiniciar titulo
          this.state
            .chartListPCDT
            .cPCDTMapaIncidenciasInstance
            .legend.update({
              title: {text: ''}
            })
            
          //Reiniciar classColor
          this.state
            .chartListPCDT
            .cPCDTMapaIncidenciasInstance
            .colorAxis[0].update({
              dataClasses: []
            })

            //reiniciar series
          this.state
          .chartListPCDT
          .cPCDTMapaIncidenciasInstance.series[0]
          .setData([])
        }
      this.setState({
        chartListPCDT: {
          ...this.state.chartListPCDT,
          cPCTMapaIncidenciasIncidencias: []
        }
      })
      
      let objTarget = this.state
        .chartListPCDT
        .cPCDTPuntCalInciTraMapData.find(item => item.especie === e.target.value)

      this.onChange_checkSpecies({ target: e.target })
      // if (objTarget === undefined) return false;

    
      let ccc = false
      try {

        ccc = objTarget === undefined && objTarget.incidencias === undefined
      } catch (e) {
        ccc = true
      }
      // if (objTarget.incidencias === undefined) {
      //   ccc = true
      //   // return false
      // };
      let formatData = ccc ? [] : objTarget
          .incidencias
          .map(itemP => [itemP[0].toLowerCase(), itemP[2]])

        let colorAxisClass = formatData.map(item => +item[1]).filter((a, b, c) => c.indexOf(a) === b).sort((a, b) => a - b).map(item => ({to: item, from: item}))

      this.state
        .chartListPCDT
        .cPCDTMapaIncidenciasInstance.series[0]
        .setData(ccc ? [] : formatData)

      this.state
        .chartListPCDT
        .cPCDTMapaIncidenciasInstance
        .legend
        .update({
          enabled: true,
          title: {text: ccc ? '' : `${objTarget.especie}`}
        })

      this.state
        .chartListPCDT
        .cPCDTMapaIncidenciasInstance
        .colorAxis[0].update({
          dataClasses: ccc ? [] : colorAxisClass
        })

      
    }
    onChange_selEspeciesRutTrafNacion=(e)=>{

      if(e.target.value!=='-1'){        
        this.show_RutasNacionales(this.state.chartListRT.cRTRutasNacionalesTraDataAll.filter(item => item.especie===e.target.value))
        
      }else{
        this.show_RutasNacionales([])
      }
      
    }
    show_RutasNacionales=(data)=>{
              let google=this.state.chartListRT.cRTRutasNacionalesTraGoogleMapInstance
              let map=this.cRTRutasNacionalesTraMapInstance

              this.state
              .chartListRT
              .cRTRutasNacionalesTraGoogleMapInstance
              .maps
              .event
              .trigger(this.cRTRutasNacionalesTraMapInstance,'resize')

              let Markers=this.state.chartListRT.cRTRutasNacionalesTraMarkers
              let PolyLlines=this.state.chartListRT.cRTRutasNacionalesTraPolyLines
              for (let i = 0; i < Markers.length; i++) {
                Markers[i].setMap(null);
              }
              Markers=[]
              for (let i = 0; i < PolyLlines.length; i++) {
                PolyLlines[i].setMap(null);
              }
              PolyLlines=[]
              let legend = document.getElementById('legend')
              map.controls[google.maps.ControlPosition.LEFT_BOTTOM].clear()
              map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);
              
              const infoWindow = new google.maps.InfoWindow();
              let finalData=[]
              
              
              data.forEach((item, indexI) => {//data especies
                let colorSpecie = getColorPalette('traffic', indexI)
                finalData.push({
                  ...item,
                  color: colorSpecie
                })
              
                const lineSymbol = {
                  path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                  fillColor: colorSpecie
                };
                item.data.forEach(data => {//data rutas
                  // let path = [{lat: data.origen.latLong[0], lng: data.origen.latLong[1]}]
                  const marker = new google.maps.Marker({
                    position: {lat: data.origen.latLong[0], lng: data.origen.latLong[1]},
                    map,
                    icon: {
                      path: faMapPin.icon[4],
                      fillColor: colorSpecie,
                      fillOpacity: 1,
                      anchor: new google.maps.Point(
                        faMapPin.icon[0] / 2, // width
                        faMapPin.icon[1] // height
                      ),
                      strokeWeight: 1,
                      strokeColor: "#ffffff",
                      scale: 0.075,
                    },
                    
                    title: `${item.product_type}`,
                    // label: `${item.especie + '1222'}`,
                    optimized: false,
                  });

              
                  // Add a click listener for each marker, and set up the info window.
                  
                  data.destinos.forEach(destino => {
                    marker.addListener("click", () => {
                      infoWindow.close();
                      infoWindow.setContent(`
                      <div class="">
                        <header class="card-header">
                          <p class="card-header-title p-0 m-0"><span class="icon"><i
                                class="mdi mdi-arrow-right-bold default"></i></span>
                                <span><b>${data.origen.name}</b></span>
                          </p>
                        </header>
                        <div class="card-content p-2">
                          <div class="level is-mobile">
                            <div class="level-item">
                              <div class="is-widget-label">
                                <h3 class="subtitle is-spaced" style="font-size: 1.1rem">${item.especie}</h3>
                                <h3 class="title has-text-centered" style="font-size: 1.1rem;">
                                  <div>${destino.cantidad || ''} ${destino.unit.replace('"', '').replace('"', '') || ''}</div>
                                </h3>
                                <h4 class="title has-text-centered" style="font-size: 0.9rem;">
                                  <div><i>"${destino.producto || ''}"</i></div>
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      `);
                      infoWindow.open(marker.getMap(), marker);
                    });
                    Markers.push(marker)
                    PolyLlines.push(new google.maps.Polyline({
                      path: [
                        {lat: data.origen.latLong[0], lng: data.origen.latLong[1]},
                        {lat: destino.latLong[0], lng: destino.latLong[1]},
                      ],
                      icons: [
                        {
                          icon: lineSymbol,
                          offset: "100%",
                          fillColor: colorSpecie
                        },
                      ],
                      strokeColor: colorSpecie,
                      strokeOpacity: 1.0,
                      strokeWeight: 1.5,
                      map: map,
                    }))
                  })
                })
               

                this.setState({
                  chartListRT: {
                    ...this.state.chartListRT,
                    cRTRutasNacionalesTraData: finalData,
                    cRTRutasNacionalesTraPolyLines: PolyLlines,
                    cRTRutasNacionalesTraMarkers: Markers
                  }
                })

                
              })
    }
    load_cMDTipoProducto = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'MDTipoProducto',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        let data = res.data.data
     
        this.setState({
          chartListMD: {
            ...this.state.chartListMD,
            cMDTipoProductoData: data,
            cMDTipoProductoTitle: res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")",
            cMDTipoProductoEspecies: data.map((item, index) => [index, item.especie])
          }
        })

        this.setState({
          chartListMD: {
            ...this.state.chartListMD,
            cMDTipoProducto: <MDTipoProducto key="MDTipoProducto"
              title={res.data.title} 
              description={res.data.description} 
              data={ data }
              callback={chart => {
                // chart
                //   .legend
                //   .update({enabled: false})

                this.setState({
                  chartListMD: {
                    ...this.state.chartListMD,
                    cMDTipoProductoInstance: chart
                  }
                })
              }}
              />,
          }
        })
      })
    }
    generate_cPCDTPuntCalInciTraTitle = () => {
      return this.state.chartListPCDT.cPCDTPuntCalInciTraTitle.replace('VAR_ESPECIE', this.state.cPCDTPuntCalInciTraTitleCurrent)
    }
    onChange_checkSpecies = (e) => {
      
      let find = undefined
      this.state.cPCDTPuntCalInciTraListFound.forEach(item => {
        
        if (item.especie === e.target.value) {
          find = item
          item.cInstance.set("opacity", 0.7)
        } else {
          item.cInstance.set("opacity", 0)
        }
      })
      this.state
        .chartListPCDT
        .cPCDTPuntCalInciTraGoogleMapInstance
        .maps
        .event
        .trigger(this.cPCDTPuntCalInciTraMapInstance,'resize')
      if (find !== undefined) {
        this.setState({
          cPCDTPuntCalInciTraTitleCurrent: e.target.value
        })
        // find.cInstance.opacity = e.target.checked ? 1 : 0
        // find.cInstance.set("opacity", e.target.checked ? 0.7 : 0)
        return false
      }
      
      if (+e.target.value === -1) {
        return false
      }
            let resEsp = this.state.cPCDTPuntCalInciTraList.find(item => e.target.value === item.especie)

            let heat = new this.state
              .chartListPCDT
              .cPCDTPuntCalInciTraGoogleMapInstance
              .maps
              .visualization
              .HeatmapLayer({
                data: resEsp.puntos.map(item =>  new this.state
                  .chartListPCDT
                  .cPCDTPuntCalInciTraGoogleMapInstance
                  .maps
                  .LatLng(item.latitude, item.longitude)),
                  map: this.cPCDTPuntCalInciTraMapInstance,
                  radius: 30,
                  dissipating: true,
                  opacity: 0.7,
                  gradient: [
                        "rgba(239, 177, 142, 0)",
                        "rgba(239, 177, 142, 1)",
                        "rgba(235, 160, 135, 1)",
                        "rgba(230, 145, 121, 1)",
                        "rgba(225, 130, 111, 1)",
                        "rgba(220, 115, 95, 1)",
                        "rgba(218, 109, 85, 1)",
                        "rgba(213, 106, 73, 1)",
                        "rgba(212, 92, 67, 1)",
                        "rgba(211, 78, 59, 1)",
                        "rgba(209, 65, 51, 1)",
                        "rgba(208, 54, 43, 1)",
                        "rgba(205, 43, 35, 1)",
                        "rgba(202, 33, 27, 1)",
                        "rgba(200, 23, 19, 1)",
                  ]
              })
            // let list = this.state.cPCDTPuntCalInciTraListFound
            // list.push({especie: e.target.value, cInstance: heat})
            this.setState({
              // chartListPCDT: {
              //   ...this.state.chartListPCDT,
              //   cPCDTPuntCalInciTraTitle: e.target.value
              // },
              cPCDTPuntCalInciTraListFound: [
                ...this.state.cPCDTPuntCalInciTraListFound,
                {especie: e.target.value, cInstance: heat}
              ]
            })
      // })
    }
    load_cPCDTPuntCalInciTra = () => {

      this.setState({
        chartListPCDT: {
          ...this.state.chartListPCDT,
          cPCDTMapaIncidencias: <PCDTMapaIncidencias key="PCDTMapaIncidencias"
          // description={ this.state.chartListPCDT.cPCTMapaIncidenciasTitleDescription }
          callback={chart => {
            // chart
            //   .legend
            //   .update({enabled: false})

            this.setState({
              chartListPCDT: {
                ...this.state.chartListPCDT,
                cPCDTMapaIncidenciasInstance: chart
              }
            })
          }}
          />,
          cPCDTPuntCalInciTra: <MapGoogle2 key="MapGoogle2_1"
          title={'title'} 
          height="30em"
          options={{
            zoom: 3,
            disableDefaultUI: true,
            center: { lat: -19.8357364, lng: -66.2325682 },
            mapTypeId: "roadmap",

          }}
          onMapLoad={(map, google) => {
            this.cPCDTPuntCalInciTraMapInstance = map
            this.setState({
              chartListPCDT: {
                ...this.state.chartListPCDT,
                // cPCDTPuntCalInciTraMapInstance: map,
                cPCDTPuntCalInciTraGoogleMapInstance: google
              }
            })
           
          }}
          loader={SpinLoaderStyle}
          data={[]}
          />,
        }
      })

      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'cPCDTPuntCalInciTra',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          // cPCDTPuntCalInciTraList: res.data.data.map(item => item.especie)
          cPCDTPuntCalInciTraList: res.data.data,
          chartListPCDT: {
            ...this.state.chartListPCDT,
            // cPCDTMapaIncidenciasData: res.data,
            cPCDTPuntCalInciTraTitle: res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")",
            cPCDTPuntCalInciTraDescription: res.data.description,
           
          }
        })
      }).then(res => {
        


        if (this.state.cPCDTPuntCalInciTraList.length === 0) {
          return false
        }
        let firstCheck = document.getElementById(`${this.state.cPCDTPuntCalInciTraList[0].especie.replace(' ', '').toLowerCase()}0`)
        if (firstCheck === undefined) {
          return false
        }
        // firstCheck.checked = false
        // firstCheck.click()

      })

      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'cPCDTPuntCalInciTraMapInstance',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        this.setState({
          // cPCDTPuntCalInciTraMapInstanceList: res.data.data,
          chartListPCDT: {
            ...this.state.chartListPCDT,
            cPCDTPuntCalInciTraMapData: res.data.data,
            cPCDTPuntCalInciTraMapInstanceTitle: res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")",
            cPCTMapaIncidenciasTitleDescription: res.data.description,
           
          }
        })
      })
    
    }

    onChange_SelTipoRerporte = (e) => {
      this.init_report_state()
      this.load_reports()
      // legend.title.text.textSetter('asd')
      
    }
    load_incidenciasYear = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'incidenciasYear',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          //[{year: 2002, value: 10.5}]
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
          //

          this.setState({
            chartList: {
              ...this.state.chartList,
              incidenciasYear: <IncidenciasYear key="IncidenciasYear"
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })

        })
    }
    load_totalIncidenciaEspecie = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'totalIncidenciaEspecie',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          //[{year: 2002, value: 10.5}]
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
          //

          this.setState({
            chartList: {
              ...this.state.chartList,
              porcentajeTotalIncidenciaEspecie: <PorcentajeTotalIncidenciasEspecies key="PorcentajeTotalIncidenciasEspecies"
              title={title} 
              description={ res.data.description } 
              data={formatData}
              
              />,
            }
          })

        })
    }
    load_porcenPOPMTotalIncidencias = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'porcenPOPMTotalIncidencias',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          //[{year: 2002, value: 10.5}]
          let title = res.data.title+' <br> ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
          //

          this.setState({
            chartList: {
              ...this.state.chartList,
              porcenPOPMTotalIncidencias: <PorcenPOPMTotalIncidencias key="PorcenPOPMTotalIncidencias"
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })

        })
    }
    load_porcenPOTotalIncidencias = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'porcenPOTotalIncidencias',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          //[{year: 2002, value: 10.5}]
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
          //

          this.setState({
            chartList: {
              ...this.state.chartList,
              porcenPOTotalIncidencias: <PorcenPOTotalIncidencias key="PorcenPOTotalIncidencias"
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })

        })
    }
    load_extraccionBaseDatosOTCA = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'extraccionBaseDatosOTCA',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          //[{year: 2002, value: 10.5}]
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
          //

          this.setState({
            chartList: {
              ...this.state.chartList,
              fuentesExtraccion: {
                ...this.state.chartList.fuentesExtraccion,
                extraccionBaseDatosOTCA: <BaseDatosOtca key="BaseDatosOtca"
                title={title} 
                description={ res.data.description } 
                data={formatData}/>,
              }
            }
          })

        })
    }
    load_porInfoAporPMOIDBOTCA = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'porInfoAporPMOIDBOTCA',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          //[{year: 2002, value: 10.5}]
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
          //

          this.setState({
            chartList: {
              ...this.state.chartList,
              fuentesExtraccion: {
                ...this.state.chartList.fuentesExtraccion,
                porInfoAporPMOIDBOTCA: <PorInfoAporPMOIDBOTCA key="PorInfoAporPMOIDBOTCA"
                title={title} 
                description={ res.data.description } 
                data={formatData}/>,
              }
            }
          })

        })
    }
    /*
    load_especiesCantidadIncidencias = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'especiesCantidadIncidencias',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          let title = res.data.title
    
          this.setState({
            chartListMD: {
              ...this.state.chartListMD,
              especiesCantidadIncidencias: <EspeciesCantidadIncidencias 
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })
        })
    }*/
    load_cOETInvolucradasIncidente = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'cOETInvolucradasIncidente',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          let formatData = res.data.data
          // console.log('aaaaaaaaaaaaaaaaaa', formatData)
          
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
    
          this.setState({
            chartListOEI: {
              ...this.state.chartListOEI,
              cOETInvolucradasIncidente: <OETInvolucradasIncidente key="OETInvolucradasIncidente"
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })

        })
    }
    load_cOETInvolucradasIncidenteTreemap = () => {

      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
        params: {
          target: 'chartMDOETInvolucradasIncidenteTreemap',
          recurso:this.refSelTipoRerporte.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        let formatData = res.data.data
        // console.log('aaaaaaaaaaaaaaaaaa', formatData)
        
        let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
  
        this.setState({
          chartListOEI: {
            ...this.state.chartListOEI,
            cOETInvolucradasIncidenteTreemap: <OETInvolucradasIncidenteTreemap key="OETInvolucradasIncidenteTreemap"
            title={title} 
            description={ res.data.description } 
            data={formatData}/>,
          }
        })

      })
      
    }
    load_cMOMetoTranspTrafEspecies = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'cMOMetoTranspTrafEspecies',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
    
          this.setState({
            chartListMOP: {
              ...this.state.chartListMOP,
              cMOMetoTranspTrafEspecies: <MOMetoTranspTrafEspecies key="MOMetoTranspTrafEspecies"
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })

        })
    }
    load_cMOEspeDetecEncontrada = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'cMOEspeDetecEncontrada',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
    
          this.setState({
            chartListMOP: {
              ...this.state.chartListMOP,
              cMOEspeDetecEncontrada: <MOEspeDetecEncontrada key="MOEspeDetecEncontrada"
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })

        })
    }
    load_cMOMetDecIncBDOTCA = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'cMOMetDecIncBDOTCA',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
    
          this.setState({
            chartListMOP: {
              ...this.state.chartListMOP,
              cMOMetDecIncBDOTCA: <MOMetDecIncBDOTCA key="MOMetDecIncBDOTCA"
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })

        })
    }
    load_cMOMetDetIncBDOTCASD = () => {
      axios.get(baseUrl(`cites/dashboardtrafico/charts`), {
          params: {
            target: 'cMOMetDetIncBDOTCASD',
            recurso:this.refSelTipoRerporte.current.value
          },
          cancelToken: this.requestInit.token
        }).then(res => {
          
          let formatData = res.data.data
          let title = res.data.title+' ('+(res.data.rango.min)+" - "+(res.data.rango.max)+")"
    
          this.setState({
            chartListMOP: {
              ...this.state.chartListMOP,
              cMOMetDetIncBDOTCASD: <MOMetDetIncBDOTCASD key="MOMetDetIncBDOTCASD"
              title={title} 
              description={ res.data.description } 
              data={formatData}/>,
            }
          })

        })
    }
    setFilter(){
        this.setState({
            filter : {
                q1: this.state.search['txt_ncc'],
                q2: this.state.search['sel_year'],
                q3: this.state.search['sel_iucn'],
                q4: this.state.search['sel_tiporecurso']
            }
        })


        
    }
  
    pointsToPath = (from, to, invertArc = true) => {
      
      var arcPointX = (from.x + to.x) / (invertArc ? 2.4 : 1.6),
          arcPointY = (from.y + to.y) / (invertArc ? 2.4 : 1.6);
      let g = 'M' + from.x + ',' + from.y + 'Q' + arcPointX + ' ' + arcPointY + ',' + to.x + ' ' + to.y;
      
      return g
    }
  

 
    componentWillUnmount() {
      
      if (this.requestInit) this.requestInit.cancel()
    }


    /*menu jocarsf */

   
  
    render() {
      
        return <Templates.Default.BasePageRoute2 localUrl={localUrl} dataPage={this.props.DataPage}>
          {this.state.header?(
          <div>
          <div className="columns pt-3">
            <div className="column is-12">
              <div dangerouslySetInnerHTML={{__html: this.state.header.titulo }} >  
         
              </div>
              <p>
                <i dangerouslySetInnerHTML={{__html: this.state.header.subtitulo }}></i>
              </p>
             
            </div>
          </div>
          <div className="columns is-multiline">
          {this.state.header.carousel.map((item, j)  => {
                    return (
                      <div className="column is-2">
                        <div className="card jsoft-bd-0">
                        <div className="card-image img_especies_traficadas">
                            <Carousel  
                              IndicatorIcon={false} indicators={false}>
                              
                              {
                                  item.images.map((images, i) => {
                                    return (
                                      <Paper key={ i }>
                                        <img className="carousel__snapperxxx" src={ baseUrl(images)} alt="" />
                                    </Paper>
                                    )
                                  } )
                              }
                            </Carousel>                             
                        </div>
                        <div className="card-content jsoft-pad-0 pt-1">
                        <div className="media mb-3">                   
                        <div className="media-content">
                            <p className="title is-5 jsoft-green pl-1"><em>{item.title}</em> </p>
                            <div className="subtitle is-12">
                                <div className="tags has-addons">
                                  <span className="tag has-background-success-light">Apéndice {item.cite}</span>
                                </div>
                            </div>
                            </div>
                            </div>
                        </div>
                        </div>
                      </div>
                    )
          } )
          }
            </div>
            <div className="columns">
                <div className="column is-2">
                <label className="label">{this.props.language('mostrar_reporte')}</label>
                </div>
                <div className="column">
                <div className="field-body">
                  <div className="field is-narrow">
                    <div className="control">
                      <div className="select is-fullwidth">
                        <select id="sel_tipo_reporte" 
                        ref={ this.refSelTipoRerporte } 
                        onChange={ this.onChange_SelTipoRerporte }>     
                        { this.state.header.filters.apendice.map((item, index) => {
                        return <option 
                          key={ item.title + index } 
                          id={ item.title.replace(' ','').toLowerCase() + index }
                            // value={ item.especie }
                            value={ item.value }
                            selected={item.selected}
                            >{ item.title }</option>

                        }) }
                        
                      </select>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
          </div>
          
          ):SpinLoaderStyle}
          <div className="columns">
            <div className="column is-3">
              <JsoftMenu data = {this.props} />
              
            </div>
            <div className="column is-9">
           
             { true ? <Card id="infgen" className="card-traffic">
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('dashb_trafico_panel_info_gral_titulo','INFORMACIÓN GENERAL')}</span>&nbsp;&nbsp;
                                {/* <Link target="_blank" 
                                  to={ localUrl('/reportes/exportaciones?q1=') }>
                                  <span className="tag is-primary"><span>Ver detalles</span></span>
                                </Link> */}
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {
                                  ...this.state.panels, 
                                  informacionGeneral : !this.state.panels.informacionGeneral 
                                }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.informacionGeneral ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.informacionGeneral ? '' : 'is-hidden' }>
                            <div className="columns">
                               <div className="column">
                               { this.state.chartList.porcentajeTotalIncidenciaEspecie }
                               </div>
                             </div>
                             <div className="columns">
                               <div className="column is-8 is-offset-2">
                               { this.state.chartList.incidenciasYear }
                               </div>
                              
                             </div>
                             
                             <div className="columns">
                               <div className="column">
                               { this.state.chartList.porcenPOPMTotalIncidencias }
                               </div>
                               <div className="column">
                               { this.state.chartList.porcenPOTotalIncidencias }
                               </div>
                             </div>
                             <div className="columns">
                               <div className="column ">
                               { this.state.chartList.fuentesExtraccion.extraccionBaseDatosOTCA }
                               </div>
                               <div className="column">
                               { this.state.chartList.fuentesExtraccion.porInfoAporPMOIDBOTCA }
                               </div>
                             </div>
                            </Card.Content>
                        </Card> : null }
                        {/* PUNTOS DE CALOR DE TRÁFICO */}
                        { true ? <Card id="caltrafil" className="card-traffic">
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('dashb_trafico_panel_puntos_calor_titulo','PUNTOS DE CALOR DE TRÁFICO ILEGAL')}</span>&nbsp;&nbsp;
                                {/* <Link target="_blank" 
                                  to={ localUrl('/reportes/exportaciones?q1=') }>
                                  <span className="tag is-primary"><span>Ver detalles</span></span>
                                </Link> */}
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {
                                  ...this.state.panels, 
                                  puntosCalorTrafico : !this.state.panels.puntosCalorTrafico 
                                }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.puntosCalorTrafico ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.puntosCalorTrafico ? '' : 'is-hidden' }>
                             <div className="columns">
                               <div className="column is-10 is-offset-1 ">
                                 
                                 <div className="columns">
                                   <div className="column is-12">
                                              <form action="">
                                                <div className="field">
                                                  <label htmlFor="sel_especies_calor_trafico"
                                                    className="label is-capitalize">{ this.props.language('especies')
                                                    }</label>
                                                  <div className="control is-expanded">
                                                    <span className="select is-empty">
                                                      <select id="sel_especies_calor_trafico" 
                                                        disabled={ this.state.chartListPCDT.cPCDTPuntCalInciTraMapData.length===0 } 
                                                        ref={ this.refSelIncidenciasCalorTrafico } 
                                                        onChange={ this.onChange_checkSpeciesPCTracIle }
                                                        style={{fontStyle: 'italic'}}
                                                        >
                                                        <option value="-1">--{ this.props.language('seleccione_especies') }--
                                                        </option>
                                                        { this.state.cPCDTPuntCalInciTraList.map((item, index) => {
                                                        return <option 
                                                          key={ item.especie + index } 
                                                          id={ item.especie.replace(' ','').toLowerCase() + index }
                                                            // value={ item.especie }
                                                            value={ item.especie }
                                                            >{ item.especie }</option>

                                                        }) }
                                                        
                                                      </select>
                                                    </span>
                                                  </div>
                                                </div>
                                        
                                            </form>
                                
                                  </div>
                                </div>
                                <div className="columns">
                                  <div className="column is-6">
                                    <div className="columns">
                                    <div className="column is-full  has-text-centered" style={{fontSize: '0.9em'}}>
                                      <div style={{fontSize: '0.9em'}}>

                                        <span style={{
                                              color: '#000',
                                              fontSize: '1.4em',
                                              fontWeight: 'bold',
                                              fill: '#000'
                                        }}>{ this.state.chartListPCDT.cPCDTPuntCalInciTraTitle }</span>
                                      </div>
                                      <div className="column is-full">
                                        { this.state.chartListPCDT.cPCDTPuntCalInciTra }
                                      </div>
                                      <div className="has-text-centered" style={{fontSize: '0.9em'}}>
                                        <p className="px-6" style={{
                                              color: '#000',
                                              fontSize: '1.1em',
                                              
                                              fill: '#000'
                                        }}><i>{ this.state.chartListPCDT.cPCDTPuntCalInciTraDescription }</i></p>
                                        </div>
                                    </div>
                                  </div>
                                      
                                  </div>
                                  <div className="column is-6">
                                  <div className="columns">
                                    <div className="column is-full  has-text-centered" style={{fontSize: '0.9em'}}>
                                      <div style={{fontSize: '0.9em'}}>

                                        <span style={{
                                              color: '#000',
                                              fontSize: '1.4em',
                                              fontWeight: 'bold',
                                              fill: '#000'
                                        }}>{ this.state.chartListPCDT.cPCDTPuntCalInciTraMapInstanceTitle }</span>
                                      </div>
                                      <div className="column is-full">
                                        { this.state.chartListPCDT.cPCDTMapaIncidencias }
                                      </div>
                                      <div className="has-text-centered" style={{fontSize: '0.9em'}}>
                                        <p className="px-6" style={{
                                              color: '#000',
                                              fontSize: '1.1em',
                                              
                                              fill: '#000'
                                        }}><i>{ this.state.chartListPCDT.cPCTMapaIncidenciasTitleDescription }</i></p>
                                        </div>
                                    </div>
                                  </div>
                                    
                                  </div>
                                </div>
                               </div>
                             
                             </div>
                            </Card.Content>
                        </Card> : null }
                        { true ? <Card id="ruttrafil" className="card-traffic">
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('dashb_trafico_panel_rutas_trafico_titulo','RUTAS DE TRÁFICO ILEGAL')}</span>&nbsp;&nbsp;
                                {/* <Link target="_blank" 
                                  to={ localUrl('/reportes/exportaciones?q1=') }>
                                  <span className="tag is-primary"><span>Ver detalles</span></span>
                                </Link> */}
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {
                                  ...this.state.panels, 
                                  rutasTrafico : !this.state.panels.rutasTrafico 
                                }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.rutasTrafico ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.rutasTrafico ? '' : 'is-hidden' }>
                             <div className="columns">
                               <div className="column">
                                { this.state.chartListRT.cRTTraficoEspecies }
                               </div>
                             </div>
                             <div className="columns">
                              {/*
                              <div className="column">
                                { this.state.chartListMD.especiesCantidadIncidencias }
                               </div>
                            */}
                               <div className="column">
                                 <div className="columns">
                                   <div className="column is-full  has-text-centered" style={{fontSize: '0.9em'}}>
                                     <div style={{fontSize: '0.9em'}}>

                                      <span style={{
                                            color: '#000',
                                            fontSize: '1.4em',
                                            fontWeight: 'bold',
                                            fill: '#000'
                                      }}>{ this.state.chartListRT.cRTRutasNacionalesTraTitle }</span>
                                     </div>
                                   </div>
                                 </div>
                                 {this.state.chartListRT.cRTRutasNacionalesTraDataEspecies.length>0?(
                                 <form action="">
                                  <div className="columns is-vbottom">
                                    <div className="column is-6 pt-0 mb-2">
                                      <div className="field"><label htmlFor="sel_especies" className="label is-capitalize">{ this.props.language('especies') }</label>
                                        <div className="control is-expanded"><span className="select is-empty">
                                          <select id="sel_especies"  onChange={ this.onChange_selEspeciesRutTrafNacion }
                                          style={{fontStyle: 'italic'}}
                                          >
                                              <option value="-1">--{ this.props.language('seleccione_especies') }--</option>
                                              { this.state.chartListRT.cRTRutasNacionalesTraDataEspecies.map((item, index) => {
                                                return <option key={ index } value={ item }>{ item }</option>

                                              }) }
                                              
                                            </select>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </form>):''
                                }
                                { this.state.chartListRT.cRTRutasNacionalesTra }
                                <div id="legend"  className={ 'cLegend ' + (this.state.chartListRT.cRTRutasNacionalesTraData.length > 0 ? '' : 'is-hidden' )}>
                                  <h3>Espécimen traficada</h3>
                                  <div>
                                    <div className="lc-serie">
                                      <ul>
                                        { this.state.chartListRT.cRTRutasNacionalesTraData.map((item, indexLI) => {
                                          return (
                                            <li key={ indexLI }>
                                              <div className="lc-color" style={{
                                                backgroundColor: item.color
                                              }}></div>
                                              <div className="lc-title">
                                                <span className="lc-title">{ item.product_type }</span>
                                              </div>
                                            </li>
                                          )
                                        }) }
                                        
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                               </div>
                             </div>
                            </Card.Content>
                        </Card> : null }
                        {/* PRINCIPALES MERCADOS Y DEMANDAS */}
                        { true ? <Card id="prinmerd" className="card-traffic">
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('dashb_trafico_panel_pincip_mercados_titulo','PRINCIPALES MERCADOS Y DEMANDAS')}</span>&nbsp;&nbsp;
                                {/* <Link target="_blank" 
                                  to={ localUrl('/reportes/exportaciones?q1=') }>
                                  <span className="tag is-primary"><span>Ver detalles</span></span>
                                </Link> */}
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {
                                  ...this.state.panels, 
                                  principalesMercadosDemandas : !this.state.panels.principalesMercadosDemandas 
                                }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.principalesMercadosDemandas ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.principalesMercadosDemandas ? '' : 'is-hidden' }>
                             <div className="columns">                               
                               <div className="column is-6 is-offset-3">
                                 <div className="columns">
                                 <div className="column is-full  has-text-centered" style={{fontSize: '0.9em'}}>
                                     <div style={{fontSize: '0.9em'}}>

                                      <span style={{
                                            color: '#000',
                                            fontSize: '1.4em',
                                            fontWeight: 'bold',
                                            fill: '#000'
                                      }}>{ this.state.chartListMD.cMDTipoProductoTitle }</span>
                                     </div>
                                   </div>
                                 </div>

                                 <form action="">
                                   <div className="columns is-vbottom">
                                     <div className="column is-6">
                                       <div className="field"><label htmlFor="sel_especies" className="label is-capitalize">{ this.props.language('especies') }</label>
                                         <div className="control is-expanded"><span className="select is-empty">
                                            <select id="sel_especies" ref={ this.refSelEspecies } onChange={ this.onChange_selEspecies } style={{fontStyle: 'italic'}}>
                                               <option value="-1">--{ this.props.language('seleccione_especies') }--</option>
                                               { this.state.chartListMD.cMDTipoProductoEspecies.map((item, index) => {
                                                 return <option key={ index } value={ item[0] }>{ item[1] }</option>

                                               }) }
                                               
                                             </select>
                                            </span>
                                          </div>
                                       </div>
                                     </div>
                                     <div className="column is-6">
                                       <div className="field"><label htmlFor="sel_reyno" className="label is-capitalize">{ this.props.language('producto') }</label>
                                         <div className="control is-expanded">
                                           <span className="select is-empty">
                                           <select id="sel_producto" ref={ this.refSelProductos } onChange={ this.onChange_selProducto }>
                                               <option value="-1">-- { this.props.language('seleccione_producto') } --</option>
                                               { this.state.chartListMD.cMDTipoProductoProductos.map((item, index) => {
                                                 return <option key={ index } value={ item[0] }>{ item[1] }</option>

                                               }) }
                                               
                                             </select></span></div>
                                       </div>
                                     </div>
                                   </div>
                                 </form>
                                { this.state.chartListMD.cMDTipoProducto }
                               </div>
                             </div>
                            </Card.Content>
                        </Card> : null }
                        {/* OTRAS ESPECIES TRAFICADAS */}
                        { true ? <Card  id="esptraf" className="card-traffic">
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('dashb_trafico_panel_especies_traficadas_titulo','OTRAS ESPECIES TRAFICADAS ILEGALMENTE')}</span>&nbsp;&nbsp;
                                {/* <Link target="_blank" 
                                  to={ localUrl('/reportes/exportaciones?q1=') }>
                                  <span className="tag is-primary"><span>Ver detalles</span></span>
                                </Link> */}
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {
                                  ...this.state.panels, 
                                  otrasEspeciesTraficadas : !this.state.panels.otrasEspeciesTraficadas 
                                }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.otrasEspeciesTraficadas ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.otrasEspeciesTraficadas ? '' : 'is-hidden' }>
                             <div className="columns">
                              <div className="column  is-10 is-offset-1">
                               { this.state.chartListOEI.cOETInvolucradasIncidenteTreemap }

                               </div>
                             </div>  
                            </Card.Content>
                        </Card> : null }
                        {/* MODUS OPERANDI */}
                        { true ? <Card id="modope" className="card-traffic">
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('dashb_trafico_panel_modus_operandi_titulo','MODUS OPERANDI')}</span>
                                &nbsp;
                                <span className="has-tooltip-multiline" data-tooltip="En el área de la criminología se utiliza la palabra en latín modus operandi, para explicar los procedimientos llevados a cabo por una o varias personas para cometer un delito.">

                                  <i className="fas fa-info-circle"  style={ styleInfo } titlex=""></i>
                                </span>
                                {/* <Link target="_blank" 
                                  to={ localUrl('/reportes/exportaciones?q1=') }>
                                  <span className="tag is-primary"><span>Ver detalles</span></span>
                                </Link> */}
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {
                                  ...this.state.panels, 
                                  modusOperandi : !this.state.panels.modusOperandi 
                                }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.modusOperandi ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.modusOperandi ? '' : 'is-hidden' }>
                             <div className="columns">
                               <div className="column">
                               { this.state.chartListMOP.cMOMetoTranspTrafEspecies }
                               </div>
                               <div className="column">
                               { this.state.chartListMOP.cMOEspeDetecEncontrada }
                               </div>
                            
                             </div>
                             <div className="columns">
                               <div className="column">
                               { this.state.chartListMOP.cMOMetDecIncBDOTCA }
                               </div>
                               <div className="column">
                               { this.state.chartListMOP.cMOMetDetIncBDOTCASD }
                               </div>
                            
                             </div>
                            </Card.Content>
                        </Card> : null }
                        {/* FACTORES QUE IMPULSA EL TRÁFICO */}
                        { true ? <Card id="factimptrafil" className="card-traffic">
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('dashb_trafico_panel_factores_trafico_titulo','FACTORES QUE IMPULSAN EL TRÁFICO ILEGAL')}</span>&nbsp;&nbsp;
                                {/* <Link target="_blank" 
                                  to={ localUrl('/reportes/exportaciones?q1=') }>
                                  <span className="tag is-primary"><span>Ver detalles</span></span>
                                </Link> */}
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {
                                  ...this.state.panels, 
                                  factoresImpulsanTraf : !this.state.panels.factoresImpulsanTraf 
                                }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.factoresImpulsanTraf ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.factoresImpulsanTraf ? '' : 'is-hidden' }>
                             <div className="columns">
                               <div className="column is-10 is-offset-1">
                               { this.state.chartListFIT.cFITRazonComActoIlegTra }
                               </div>
                              
                            
                             </div>
                             <div className="columns">
                             <div className="column is-6">
                               { this.state.chartListFIT.cFITMultasSancionesFiveEsp }
                               </div>
                               <div className="column is-6">
                               { this.state.chartListFIT.cFITEstMultUSDIncidFiveEsp }
                               </div>
                             </div>
                             <div className="columns">                               
                               <div className="column is-8 is-offset-2">
                               { this.state.chartListFIT.cFITValoEstiUSDTipProdEsp }
                               </div>
                             </div>
                            </Card.Content>
                        </Card> : null }

              </div>
          </div>
          </Templates.Default.BasePageRoute2>
    }
}
export default connect(getMapStateDefault(), {
  set_datapage,
  // seDatatDocumentos,
  // setEstandarData,
  // checkEstandarData,
  // checkDataDirectorio,
})(DashboardTrafico);
